import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { WhatsAppButton } from "@/components/layout/WhatsAppButton";
import { HeroSection } from "@/components/home/HeroSection";
import { BrandShowcase } from "@/components/home/BrandShowcase";
import { AboutPreview } from "@/components/home/AboutPreview";
import { FeaturedProducts } from "@/components/home/FeaturedProducts";
import { WhyChooseUs } from "@/components/home/WhyChooseUs";
import { Testimonials } from "@/components/home/Testimonials";
import { FinalCTA } from "@/components/home/FinalCTA";
import { SEOHead } from "@/components/seo/SEOHead";
import { OrganizationStructuredData, LocalBusinessStructuredData, WebSiteStructuredData } from "@/components/seo/StructuredData";

const Index = () => {
  return (
    <div className="min-h-screen">
      <SEOHead
        title="Authentic Skincare Products in Lagos"
        description="Discover authentic skincare products curated for your unique skin journey. Expert guidance, trusted global brands like CeraVe, and personalized skincare routines. Based in Lekki, Lagos, Nigeria."
        keywords="skincare, authentic skincare products, Lagos skincare, Nigeria skincare, CeraVe Nigeria, skincare routine, acne treatment, hyperpigmentation, sunscreen Nigeria"
      />
      <OrganizationStructuredData />
      <LocalBusinessStructuredData />
      <WebSiteStructuredData />
      <Header />
      <main>
        <HeroSection />
        <BrandShowcase />
        <AboutPreview />
        <FeaturedProducts />
        <WhyChooseUs />
        <Testimonials />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Index;
